"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _remoteScriptInjector = require("@insided/shared/utils/remoteScriptInjector");

var _zod = require("zod");

var _SpacesDOMWrapper = _interopRequireDefault(require("./SpacesDOMWrapper"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _BrandConfigContext = require("@insided/shared/services/BrandConfigContext");

var _LoadingSpinner = _interopRequireDefault(require("@insided/shared/icons/LoadingSpinner"));

var _Core = require("@insided/destination/modules/Core");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'spaces_integration';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-spaces_integration';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  data: _zod.z.object({
    targetUrl: _zod.z.string(),
    otp: _zod.z.string()
  }).nullable(),
  error: _zod.z.unknown().nullable(),
  url: _zod.z.string().nullable()
});

exports.config = config;

var Spaces = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Spaces, _Component);

  var _super = _createSuper(Spaces);

  function Spaces() {
    var _this;

    (0, _classCallCheck2.default)(this, Spaces);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scriptElement", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: true,
      errorMessage: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptLoad", function () {
      _this.setState({
        loading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onScriptError", function () {
      // eslint-disable-next-line no-console
      console.log('Failed to load remote script');

      _this.setState({
        errorMessage: 'Failed to load remote script',
        loading: false
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Spaces, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _insidedDataStorage.getInsidedData)('user').userid == null) {
        window.addEventListener('AppEvent', function () {
          var guestUserEvent = new window.CustomEvent('GuestUserAction');
          window.dispatchEvent(guestUserEvent);
        });
        return;
      }

      if (this.props.url === null) {
        return;
      }

      this.scriptElement = (0, _remoteScriptInjector.mountRemoteEntryScript)({
        url: this.props.url,
        remoteName: 'spaces',
        module: 'default'
      }, this.onScriptLoad, this.onScriptError);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          loading = _this$state.loading,
          errorMessage = _this$state.errorMessage;

      if ((0, _insidedDataStorage.getInsidedData)('user').userid == null) {
        return (0, _preact.h)("div", null, "Access Denied");
      }

      if (this.props.url === null) {
        return (0, _preact.h)("div", null, "Missing Spaces CDN URL");
      }

      if (errorMessage) {
        return (0, _preact.h)(_Core.ErrorPage, {
          errorMessage: errorMessage
        });
      }

      if (this.props.error) {
        return (0, _preact.h)(_Core.ErrorPage, {
          errorMessage: JSON.stringify(this.props.error)
        });
      }

      if (loading) {
        return (0, _preact.h)("div", {
          className: "loader-container"
        }, (0, _preact.h)(_LoadingSpinner.default, {
          className: "icon-loading-spinner"
        }));
      }

      var data = this.props.data;

      if (data === null) {
        return (0, _preact.h)("div", null, "Missing credentials data");
      }

      return (0, _preact.h)(_BrandConfigContext.BrandConfigContext.Consumer, null, function (_ref) {
        var config = _ref.config;
        return (0, _preact.h)(_SpacesDOMWrapper.default, (0, _extends2.default)({}, data, {
          config: config
        }));
      });
    }
  }]);
  return Spaces;
}(_preact.Component);

var _default = Spaces;
exports.default = _default;